import { createEntityCollectionStore } from '@recruitee/ngrx';
import type { OfferItem } from '@recruitee/offers-types';

import { EntityStoreKey } from '../../types';

const {
  namespace,
  actions: defaultActions,
  reducer,
  selectors: { byId },
} = createEntityCollectionStore<{
  offers: OfferItem[];
  id: string;
}>()(EntityStoreKey.OffersByCompany);

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

const OffersByCompanySelectors = { byId };

export {
  actions as OffersByCompanyActions,
  reducer as OffersByCompanyReducer,
  OffersByCompanySelectors,
  namespace as OffersByCompanyNamespace,
};
